import { Box, Grid2, CircularProgress } from "@mui/material";
import {
  scrollContainerStyles,
  circularProgressStyles,
  noCommunitiesTextStyles,
  gridItemStyles,
  filterLoaderBoxStyles,
} from "../styles/styles.js";
import CommunityCard from "../../../../Components/CommunityCard";
import CustomTypography from "../../../../Components/Typography";
import { useTranslation } from "react-i18next";

const BodyContent = (props) => {
  const {
    isLoading,
    isFilterLoading,
    communities,
    containerRef,
    handleScroll,
    debouncedSearch,
    pendingJoinRequests = [],
  } = props;

  const { t } = useTranslation("page-find-communities");

  return (
    <>
      <Box
        className="custom-scrollbar"
        sx={{
          ...scrollContainerStyles,
          pointerEvents: isFilterLoading ? "none" : "auto",
        }}
        ref={containerRef}
        onScroll={handleScroll}
      >
        {isFilterLoading && (
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 99,
            }}
          >
            <Box sx={filterLoaderBoxStyles}>
              <CircularProgress sx={{ color: "#46A091" }} />
            </Box>
          </Box>
        )}

        {debouncedSearch.length === 1 ? (
          <CustomTypography sx={noCommunitiesTextStyles}>
            {t("min_2_characters")}
          </CustomTypography>
        ) : communities?.length === 0 && !isLoading && !isFilterLoading ? (
          <CustomTypography sx={noCommunitiesTextStyles}>
            {t("no_communities")}
          </CustomTypography>
        ) : (
          <Box>
            <Grid2 container columnSpacing={3} rowSpacing={2}>
              {communities?.map((item, index) => {
                // Check if this community has a pending join request
                const hasJoinRequest = pendingJoinRequests.includes(item.id);

                return (
                  <Grid2
                    item
                    size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4, "2xl": 3 }}
                    key={index + item?.full_name}
                    sx={gridItemStyles}
                  >
                    <CommunityCard
                      communityData={item}
                      initialRequestState={hasJoinRequest}
                    />
                  </Grid2>
                );
              })}
            </Grid2>
          </Box>
        )}
        {isLoading && !isFilterLoading && (
          <Box sx={circularProgressStyles}>
            <CircularProgress sx={{ color: "#46A091" }} />
          </Box>
        )}
      </Box>
    </>
  );
};

export default BodyContent;
